import axiosApiClient from '..';
import { handleError, throwErrorIfWrongStatus } from './utils';

const BASE_URL = 'api/telescope';

class InfluencerServiceClass {
  getInfluencers = async (page, search, sortBy) => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      if (search) {
        params.append('search', search);
      }
      if (sortBy) {
        params.append('sortBy', sortBy);
      }
      const response = await axiosApiClient.get(`${BASE_URL}/influencers?${params.toString()}`);
      throwErrorIfWrongStatus(response, 200);
      const { data, total, perPage: perPageResponse } = response.data.data;
      return { data, maxReached: total <= +page * +perPageResponse, page };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching influencers.');
    }
  };

  getInfluencerById = async id => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/influencers/${id}`);
      throwErrorIfWrongStatus(response, 200);
      const { influencer } = response.data.data;
      return { influencer };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching influencer.');
    }
  };

  getInfluencerFeed = async (influencerId, limit, cursor) => {
    try {
      const params = new URLSearchParams();

      if (limit) {
        params.append('limit', limit);
      }
      if (cursor) {
        params.append('cursor', cursor);
      }

      const query = params.toString();
      const encodedInfluencerId = encodeURIComponent(influencerId);
      const response = await axiosApiClient.get(
        query ? `${BASE_URL}/feed/${encodedInfluencerId}?${query}` : `${BASE_URL}/feed/${encodedInfluencerId}`,
      );

      throwErrorIfWrongStatus(response, 200);

      const { data, pagination } = response.data.data;

      return { data, pagination };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching influencer feed.');
    }
  };
}

const InfluencerService = new InfluencerServiceClass();
export default InfluencerService;
